<div class="apotheken-reservierung">
    <img src="/images/private/swiss/Apotheken Auswahl.svg" alt="Apotheken Auswahl.svg"/>
</div>
